module.exports = __webpack_public_path__ + "img/default-logo.7547b85a.png";